import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Drawer, Spin } from "antd";
import "./SideBar.css";
import { ConfigProvider, Tooltip } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import yellowSpotLogo from "../../assets/CombineLogo.jpg"
import { MdHeight } from "react-icons/md";
import { HiChevronRight } from "react-icons/hi";
import { IoIosMenu } from "react-icons/io";
import { MdOutlineCancel } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";

function SideBarComponent({
  data,
  modulesLoading = false,
  handleTabClick,
  activeTabClick,
  handleSideBarCollapse,
  handleSideBarOpen,
  handleSideBarClose,
  collapsed,
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 769);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 769);
  };
  const activeTabRed = useSelector(state => state.inventoriesList.activeTab)
  const [activeTab, setActiveTab] = useState(activeTabClick);
  const [iconDelay, setIconDelay] = useState(collapsed);
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    setActiveTab(activeTabRed)
  }, [activeTabRed])

  useEffect(() => {
    const timer = setTimeout(() => {
      setIconDelay(collapsed);
    }, 2000);

    return () => clearTimeout(timer);
  }, [collapsed]);

  const styles = {
    width: isMobile ? (collapsed ? '0px' : '243px') : (collapsed ? '80px' : '243px'),
    transition: "all 300ms ease"
    // position:"absolute",
    // top:"0px",
    // zIndex:"55555",
    // backgroundColor:"white"
  };
  const NewStyle = {
    visibility: isMobile ? (collapsed ? 'hidden' : 'visible') : 'visible',
    opacity: isMobile ? (collapsed ? 0 : 1) : 1,
    transition: "all 300ms ease"
  }

  // Create the sidebar content - exact same as original
  // On desktop: hover over sidebar keeps it open, mouse leave closes it
  const sidebarContent = (
    <div
      className="main-sidebar"
      onMouseEnter={!isMobile ? handleSideBarOpen : undefined}
      onMouseLeave={!isMobile ? handleSideBarClose : undefined}
    >
      <div
        className="main-sidebar-child"
        style={styles}
      >
        <div className="main-sidebar-logo">
          <Link to="/dashboard"><img className="client-logo" src={yellowSpotLogo} /></Link>
          <Button onClick={handleSideBarCollapse}>
            {iconDelay ? <IoIosMenu /> : <IoIosArrowBack />}
          </Button>
        </div>

        <div className="main-sidebar-navigation" style={NewStyle}>
          {modulesLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
              <Spin />
            </div>
          ) : (
            <>
              {data &&
                data.map((ele) => {
                  return (
                    <Link
                      className="main-sidebar-navigation-tab"
                      style={{
                        backgroundColor: activeTab == ele.src ? "#FFCB10" : null,
                        transition: "300ms ease",
                        justifyContent: collapsed ? "center" : "left",
                      }}
                      to={ele.src}
                      onClick={() => handleTabClick(ele.src)} // Pass src
                      key={ele.src}
                    >
                      <Tooltip placement="right" title={ele.tab}>
                        {typeof ele.icon === "string" ? (
                          <img className="icon-svg" src={ele.icon} alt={ele.tab} />
                        ) : (
                          <div style={{ fontSize: "24px", display: "flex" }}>{ele.icon}</div>
                        )}
                      </Tooltip>
                      <div
                        className="LinksFont"
                        style={{ display: collapsed ? "none" : "block" }}
                        key={ele.tab}
                        onClick={isMobile ? handleSideBarCollapse : undefined}
                      >
                        {ele.tab}
                      </div>
                    </Link>
                  );
                })}
              {!modulesLoading && data?.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center", padding: "24px" }}>
                  <p style={{ color: "gray", fontWeight: "600", fontSize: "100%", margin: 0 }}>
                    No Modules Assigned
                  </p>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );

  // Conditionally render either the drawer (on mobile) or the regular sidebar content (on desktop)
  if (isMobile) {
    return (
      <>
        {/* Mobile Menu Trigger Button */}
        <Button
          className="mobile-menu-trigger"
          onClick={handleSideBarCollapse}
          type="text"
          icon={<IoIosMenu size={24} />}
          style={{
            position: "fixed",
            left: "10px",
            top: "20px",
            zIndex: 1000
          }}
        />

        {/* Mobile Drawer that contains the exact same sidebar content */}
        <div id="NavigationDrawer">
          <Drawer
            placement="left"
            onClose={handleSideBarCollapse}
            open={!collapsed}
            width={243}
            closable={false}
            bodyStyle={{ padding: 0 }}
          >
            {sidebarContent}
          </Drawer>
        </div>
      </>
    );
  }

  // For desktop: return the original sidebar content directly
  return sidebarContent;
}

export default SideBarComponent;